import { useState } from "react";
import { mockAddresses } from "../../../mocks/accountData";

export default function AddressesTab() {
  const [addresses, setAddresses] = useState(mockAddresses);

  const setDefault = (id: string) => {
    setAddresses((prev) => prev.map((a) => ({ ...a, isDefault: a.id === id })));
  };

  const removeAddress = (id: string) => {
    setAddresses((prev) => prev.filter((a) => a.id !== id));
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-6 flex-wrap gap-3">
        <div>
          <h2 className="text-2xl font-black text-cl-dark">Saved Addresses</h2>
          <p className="text-gray-500 text-sm mt-0.5">Speed up future bookings with saved locations</p>
        </div>
        <button className="bg-cl-dark text-white font-black text-sm px-5 py-2.5 rounded-xl cartoon-btn whitespace-nowrap flex items-center gap-2">
          <i className="ri-add-line"></i>
          Add Address
        </button>
      </div>

      <div className="flex flex-col gap-4">
        {addresses.map((addr) => (
          <div
            key={addr.id}
            className={`bg-white rounded-2xl thick-border p-5 flex items-start justify-between gap-4 flex-wrap ${
              addr.isDefault ? "ring-2 ring-cl-green" : "cartoon-shadow"
            }`}
          >
            <div className="flex items-start gap-4">
              <span className="w-11 h-11 flex items-center justify-center rounded-xl bg-cl-lime border-2 border-cl-dark flex-shrink-0">
                <i className="ri-map-pin-line text-cl-dark text-lg"></i>
              </span>
              <div>
                <div className="flex items-center gap-2 mb-1">
                  <p className="font-black text-cl-dark text-sm">{addr.label}</p>
                  {addr.isDefault && (
                    <span className="bg-cl-lime text-cl-dark text-xs font-black px-2 py-0.5 rounded-full border border-cl-dark">
                      Default
                    </span>
                  )}
                </div>
                <p className="text-gray-600 text-sm font-semibold">{addr.line1}</p>
                <p className="text-gray-500 text-xs">{addr.line2}, {addr.postcode}</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              {!addr.isDefault && (
                <button
                  onClick={() => setDefault(addr.id)}
                  className="text-xs font-bold text-cl-green hover:underline cursor-pointer whitespace-nowrap"
                >
                  Set Default
                </button>
              )}
              <button
                onClick={() => removeAddress(addr.id)}
                className="w-9 h-9 flex items-center justify-center rounded-xl border-2 border-transparent text-gray-400 hover:border-red-400 hover:text-red-500 transition-all cursor-pointer"
              >
                <i className="ri-delete-bin-line text-sm"></i>
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
